import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  text: 'Planning my swim lessons used to take me hours every week. Now I simply open the system and teach. My students are progressing faster than ever.',
  author: 'Jennifer M.',
  role: 'Swim Instructor',
  location: 'Florida, USA'
}, {
  text: 'The Skill Development Library alone is worth the price. Everything is organised by level and ready to use poolside immediately.',
  author: 'Michael R.',
  role: 'Aquatics Coach',
  location: 'Texas, USA'
}, {
  text: 'I teach mixed-level groups and this system finally gave me a framework I can rely on every single session.',
  author: 'Sarah T.',
  role: 'Community Pool Coordinator',
  location: 'Ontario, Canada'
}, {
  text: 'The Ready-To-Use Lessons saved me countless hours of planning. I wish I had found this in my first year of teaching.',
  author: 'David L.',
  role: 'Swim Instructor',
  location: 'Melbourne, Australia'
}, {
  text: 'As a private swim coach, keeping parents updated on progress was always a struggle. The Progress Notes Kit completely changed how I communicate, and my retention rate has skyrocketed.',
  author: 'Emily C.',
  role: 'Private Swim Coach',
  location: 'California, USA'
}];
export function Testimonials() {
  return <section className="py-8 px-4 sm:px-6 bg-white border-y-4 border-brand-gray" data-id="element-167">
      <div className="text-center mb-6" data-id="element-168">
        <h2 className="text-2xl sm:text-3xl font-heading font-black text-brand-navy mb-2 uppercase leading-tight" data-id="element-169">
          WHAT OTHER PROFESSIONALS ARE SAYING
        </h2>
        <p className="text-sm font-bold text-brand-pool uppercase tracking-wide" data-id="element-170">
          Testimonials from swim instructors
        </p>
      </div>

      <div className="flex flex-col gap-4" data-id="element-171">
        {testimonials.map((t, i) => <div key={i} className="bg-brand-gray border border-brand-gray p-4 rounded-md shadow-sm" data-id="element-172">
            <div className="flex gap-1 mb-2" data-id="element-173">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-orange text-brand-orange" data-id="element-174" />)}
            </div>
            <p className="text-brand-navy font-medium mb-3 leading-snug text-sm italic" data-id="element-175">
              "{t.text}"
            </p>
            <div className="border-t border-brand-navy/10 pt-3 flex items-center gap-3" data-id="element-176">
              <div className="w-10 h-10 rounded-full bg-brand-pool/20 flex items-center justify-center text-brand-pool font-bold text-sm border border-brand-pool/30" data-id="element-177">
                {t.author.charAt(0)}
              </div>
              <div className="leading-none" data-id="element-178">
                <p className="font-bold text-brand-navy text-sm mb-1" data-id="element-179">
                  — {t.author}
                </p>
                <p className="text-[10px] text-brand-navy/60 font-bold uppercase tracking-wide" data-id="element-180">
                  {t.role} — {t.location}
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}